import gql from 'graphql-tag';

export const GET_CELL_LIST = gql`
    query(
        $golf_group_code: String!
        $golf_code: String!
        $course: String
        $year: String
        $month: String
    ){
    GetCellListFromAdmin(
      golf_group_code: $golf_group_code
      golf_code: $golf_code
      course: $course
      year: $year
      month: $month
    ){
      cell_id
      course_code
      play_date
      play_start
      value
    }
  }
`;

export const GET_PLAY_START_COLUMN = gql`
    query(
        $golf_group_code: String!
        $golf_code: String!
        $course_code: Int
        $play_date: String!
    ){
    GetPlayStartColumn(
        golf_group_code: $golf_group_code
        golf_code: $golf_code
        course_code: $course_code
        play_date: $play_date
    ){
        cell_id
        plan_id
        fee_id
        course_code
        course_name
        play_date
        play_start
        reserve_status
        reserve_status_name
        player_left
        value
    }
    }
`;

export const GET_COURSE_LIST = gql`
query($golf_group_code: String!, $golf_code: String!)
    {
    GetCoursesList(
        golf_group_code: $golf_group_code
        golf_code: $golf_code
    ){
        course_code
        course_name
    }
}
`;

export const SYNC_PLAN_CELLS = gql`
    mutation(
    $golf_group_code: String!
    $golf_code: String!
    $cell_id: Int
    $plan_id: Int
    ){
    SyncPlanCells(
        golf_group_code: $golf_group_code
        golf_code: $golf_code
        cell_id: $cell_id
        plan_id: $plan_id
    ){
        result
    }
    }
`;

export const CREATE_CELL_INFO = gql`

    mutation(
        $golf_group_code: String!
        $golf_code: String!
        $course_code: Int!
        $play_date: String!
        $play_start: String!
        $reserve_status: Int!
        $player_left: Int!
        $update_type: Int!
    ){
    createCellInfo(
        golf_group_code: $golf_group_code
        golf_code: $golf_code
        course_code: $course_code
        play_date: $play_date
        play_start: $play_start
        reserve_status: $reserve_status
        player_left: $player_left
        update_type: $update_type
    ) {
        result
    }
}
`;

export const UPDATE_CELL_INFO = gql`

    mutation(
        $reserve_status: Int!
        $player_left: Int!
        $golf_group_code: String!
        $golf_code: String!
        $course_code: Int!
        $play_date: String!
        $play_start: String!
        $cell_id: String!
        $update_type: Int!
    ){
    updateCellInfo(
        cell_id: $cell_id
        golf_group_code: $golf_group_code
        golf_code: $golf_code
        course_code: $course_code
        play_date: $play_date
        play_start: $play_start
        reserve_status: $reserve_status
        player_left: $player_left
        update_type: $update_type
    ) {
        result
    }
    }
`;

export const DELETE_CELL_INFO = gql`
    mutation(
    $cell_id: String!
    ){
    deleteCellInfo(
        cell_id: $cell_id
    ){
        result
    }
    }`;

export const GET_CELL_STATUS = gql`
  query(
    $cell_id: [String]
  ) {
    GetCellStatus(
        cell_id: $cell_id
    ) {
      CellStatusList{
        cell_id
        reserve_status
        player_left
        link_player_left
      }
    }
  }
`;

export const GET_PLAY_DATE_MAX_MIN = gql`
    query (
        $golf_group_code: String!
        $golf_code: String!
        $course_code: String!
        $play_date: String!
    ){
        GetPlayDateMaxMin (
            golf_group_code: $golf_group_code
            golf_code: $golf_code
            course_code: $course_code
            play_date: $play_date
        ){
            max_play_start
            min_play_start
        }
    }
`;

export const CREATE_CELL_INFO_DATA = gql`
    mutation (
        $golf_group_code: String!
        $golf_code: String!
        $course_code: String!
        $play_date_start: String
        $play_date_valid: String
        $play_time_start: String
        $play_time_valid: String
        $interval: String
    ) {
        createCellInfoData(
            golf_group_code: $golf_group_code
            golf_code: $golf_code
            course_code: $course_code
            play_date_start: $play_date_start
            play_date_valid: $play_date_valid
            play_time_start: $play_time_start
            play_time_valid: $play_time_valid
            interval: $interval
        ) {
            result
        }
    }
`;
